import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import api from "../services/api";
import "./PreviousPayrollPage.css"; // Import shared CSS

const AddPreviousPayrollPage = () => {
    const { id: businessId } = useParams();
    const [employees, setEmployees] = useState([]);
    const [quarters, setQuarters] = useState(0);
    const navigate = useNavigate();

    useEffect(() => {
        const fetchEmployees = async () => {
            try {
                const { data } = await api.get(`/businesses/${businessId}/employees`);
                setEmployees(data);
            } catch (error) {
                console.error("Error fetching employees:", error);
                alert("Failed to fetch employees.");
            }
        };

        const calculateQuarters = () => {
            const currentMonth = new Date().getMonth() + 1;
            const quarter = Math.ceil(currentMonth / 3);
            setQuarters(quarter);
        };

        fetchEmployees();
        calculateQuarters();
    }, [businessId]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        const formData = new FormData(e.target);

        const payrollData = employees
            .map((employee) =>
                [...Array(quarters)].map((_, index) => {
                    const quarter = index + 1;
                    const amount = formData.get(`employee_${employee.id}_q${quarter}_amount`);
                    const fedTax = formData.get(`employee_${employee.id}_q${quarter}_fed_tax`);
                    const stateTax = formData.get(`employee_${employee.id}_q${quarter}_state_tax`);

                    if (amount || fedTax || stateTax) {
                        return {
                            employeeId: employee.id,
                            quarter,
                            amount: amount || null,
                            fedTax: fedTax || null,
                            stateTax: stateTax || null,
                        };
                    }
                    return null;
                })
            )
            .flat()
            .filter((entry) => entry !== null);

        try {
            await api.post(`/business/${businessId}/previous-payroll`, payrollData);
            alert("Payroll data saved successfully!");
            navigate(`/dashboard/business/${businessId}/start-payroll`);
        } catch (error) {
            console.error("Error saving payroll data:", error);
            alert("Failed to save payroll data.");
        }
    };

    return (
        <div className="payroll-container">
            <h2 className="page-title">Add Previous Payroll</h2>
            <button
                        style={{
                            backgroundColor: "red",
                            color: "white",
                            padding: "10px 15px",
                            fontSize: "1rem",
                            border: "none",
                            borderRadius: "4px",
                            cursor: "pointer",
                            marginBottom:"40px",
                        }}
                        onClick={() => navigate(`/dashboard/business/${businessId}/start-payroll`)}
                    >
                        Cancel
                    </button>
            {employees.length === 0 ? (
                <div style={{ textAlign: "center", marginTop: "20px" }}>
                    <p>No employees found for this business.</p>
                    <button
                        style={{
                            backgroundColor: "#3498db",
                            color: "white",
                            padding: "10px 15px",
                            fontSize: "1rem",
                            border: "none",
                            borderRadius: "4px",
                            cursor: "pointer",
                        }}
                        onClick={() => navigate(`/dashboard/business/${businessId}/add-employee`)}
                    >
                        Add Employees
                    </button>
                </div>
            ) : (
                <form onSubmit={handleSubmit}>
                    {employees.map((employee) => (
                        <div key={employee.id} className="employee-section">
                            <h3 className="employee-header">
                                {employee.first_name} {employee.last_name}
                            </h3>
                            <table className="payroll-table">
                                <thead>
                                    <tr>
                                        <th>Quarter</th>
                                        <th>Amount</th>
                                        <th>Fed Tax</th>
                                        <th>State Tax</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {[...Array(quarters)].map((_, index) => {
                                        const quarter = index + 1;
                                        return (
                                            <tr key={quarter}>
                                                <td>Q{quarter}</td>
                                                <td>
                                                    <input
                                                        type="number"
                                                        name={`employee_${employee.id}_q${quarter}_amount`}
                                                    />
                                                </td>
                                                <td>
                                                    <input
                                                        type="number"
                                                        name={`employee_${employee.id}_q${quarter}_fed_tax`}
                                                    />
                                                </td>
                                                <td>
                                                    <input
                                                        type="number"
                                                        name={`employee_${employee.id}_q${quarter}_state_tax`}
                                                    />
                                                </td>
                                            </tr>
                                        );
                                    })}
                                </tbody>
                            </table>
                        </div>
                    ))}
                    <div className="button-group">
                        <button className="save-button" type="submit">
                            Save Payroll
                        </button>
                    </div>
                </form>
            )}
        </div>
    );
};

export default AddPreviousPayrollPage;


// import React, { useEffect, useState } from "react";
// import { useNavigate, useParams } from "react-router-dom";
// import api from "../services/api";


// const AddPreviousPayrollPage = () => {
//     const { id: businessId } = useParams();
//     const [employees, setEmployees] = useState([]);
//     const [quarters, setQuarters] = useState(0);
//     const navigate = useNavigate();

//     useEffect(() => {
//         const fetchEmployees = async () => {
//             try {
//                 const { data } = await api.get(`/businesses/${businessId}/employees`);
//                 setEmployees(data);
//             } catch (error) {
//                 console.error("Error fetching employees:", error);
//                 alert("Failed to fetch employees.");
//             }
//         };

//         const calculateQuarters = () => {
//             const currentMonth = new Date().getMonth() + 1;
//             const quarter = Math.ceil(currentMonth / 3);
//             setQuarters(quarter);
//         };

//         fetchEmployees();
//         calculateQuarters();
//     }, [businessId]);

//     const handleSubmit = async (e) => {
//         e.preventDefault();
//         const formData = new FormData(e.target);

//         // Filter out empty fields and structure data
//         const payrollData = employees.map((employee) => {
//             return [...Array(quarters)].map((_, index) => {
//                 const quarter = index + 1;
//                 const amount = formData.get(`employee_${employee.id}_q${quarter}_amount`);
//                 const fedTax = formData.get(`employee_${employee.id}_q${quarter}_fed_tax`);
//                 const stateTax = formData.get(`employee_${employee.id}_q${quarter}_state_tax`);

//                 // Include data only if at least one field has a value
//                 if (amount || fedTax || stateTax) {
//                     return {
//                         employeeId: employee.id,
//                         quarter,
//                         amount: amount || null,
//                         fedTax: fedTax || null,
//                         stateTax: stateTax || null,
//                     };
//                 }
//                 return null;
//             }).filter((entry) => entry !== null);
//         }).flat();

//         try {
//             await api.post(`/business/${businessId}/previous-payroll`, payrollData);
//             alert("Payroll data saved successfully!");
//             navigate(`/dashboard/business/${businessId}/start-payroll`);
//         } catch (error) {
//             console.error("Error saving payroll data:", error);
//             alert("Failed to save payroll data.");
//         }
//     };

//     return (
//         <div>
//             <h2>Add Previous Payroll</h2>
//             {employees.length === 0 ? (
//                 <p>No employees found for this business.</p>
//             ) : (
//                 <form onSubmit={handleSubmit}>
//                     {employees.map((employee) => (
//                         <div key={employee.id}>
//                             <h3>{employee.first_name} {employee.last_name}</h3>
//                             <table>
//                                 <thead>
//                                     <tr>
//                                         <th>Quarter</th>
//                                         <th>Amount</th>
//                                         <th>Fed Tax</th>
//                                         <th>State Tax</th>
//                                     </tr>
//                                 </thead>
//                                 <tbody>
//                                     {[...Array(quarters)].map((_, index) => {
//                                         const quarter = index + 1;
//                                         return (
//                                             <tr key={quarter}>
//                                                 <td>Q{quarter}</td>
//                                                 <td>
//                                                     <input
//                                                         type="number"
//                                                         name={`employee_${employee.id}_q${quarter}_amount`}
//                                                     />
//                                                 </td>
//                                                 <td>
//                                                     <input
//                                                         type="number"
//                                                         name={`employee_${employee.id}_q${quarter}_fed_tax`}
//                                                     />
//                                                 </td>
//                                                 <td>
//                                                     <input
//                                                         type="number"
//                                                         name={`employee_${employee.id}_q${quarter}_state_tax`}
//                                                     />
//                                                 </td>
//                                             </tr>
//                                         );
//                                     })}
//                                 </tbody>
//                             </table>
//                         </div>
//                     ))}
//                     <button type="submit">Save Payroll</button>
//                 </form>
//             )}
//         </div>
//     );
// };

// export default AddPreviousPayrollPage;





// import React, { useEffect, useState } from "react";
// import { useParams } from "react-router-dom";
// import api from "../services/api";

// const AddPreviousPayrollPage = () => {
//     const { id: businessId } = useParams();
//     const [employees, setEmployees] = useState([]);
//     const [quarters, setQuarters] = useState(0);

//     useEffect(() => {
//         const fetchEmployees = async () => {
//             try {
//                 const { data } = await api.get(`/businesses/${businessId}/employees`);
//                 setEmployees(data);
//             } catch (error) {
//                 console.error("Error fetching employees:", error);
//                 alert("Failed to fetch employees.");
//             }
//         };

//         const calculateQuarters = () => {
//             const currentMonth = new Date().getMonth() + 1;
//             const quarter = Math.ceil(currentMonth / 3);
//             setQuarters(quarter);
//         };

//         fetchEmployees();
//         calculateQuarters();
//     }, [businessId]);

//     const handleSubmit = async (e) => {
//         e.preventDefault();
//         const formData = new FormData(e.target);
    
//         // Structure the data to send to the backend
//         const payrollData = employees.map((employee) => {
//             return [...Array(quarters)].map((_, index) => {
//                 const quarter = index + 1;
    
//                 // Get values for each input field
//                 const amount = formData.get(`employee_${employee.id}_q${quarter}_amount`);
//                 const fedTax = formData.get(`employee_${employee.id}_q${quarter}_fed_tax`);
//                 const stateTax = formData.get(`employee_${employee.id}_q${quarter}_state_tax`);
    
//                 // Only include this quarter's data if at least one field has a value
//                 if (amount || fedTax || stateTax) {
//                     return {
//                         employeeId: employee.id,
//                         quarter,
//                         amount: amount ? parseFloat(amount) : undefined, // Exclude empty fields
//                         fedTax: fedTax ? parseFloat(fedTax) : undefined,
//                         stateTax: stateTax ? parseFloat(stateTax) : undefined,
//                     };
//                 }
//                 return null; // Exclude this quarter if all fields are empty
//             }).filter((entry) => entry !== null); // Remove null entries
//         }).flat();
    
//         try {
//             await api.post(`/business/${businessId}/previous-payroll`, payrollData);
//             alert("Payroll data saved successfully!");
//         } catch (error) {
//             console.error("Error saving payroll data:", error);
//             alert("Failed to save payroll data.");
//         }
//     };
    
//     // const handleSubmit = async (e) => {
//     //     e.preventDefault();
//     //     const formData = new FormData(e.target);

//     //     // Structure data to send to the backend
//     //     const payrollData = employees.map((employee) => {
//     //         return [...Array(quarters)].map((_, index) => {
//     //             const quarter = index + 1;
//     //             return {
//     //                 employeeId: employee.id,
//     //                 quarter,
//     //                 amount: formData.get(`employee_${employee.id}_q${quarter}_amount`),
//     //                 fedTax: formData.get(`employee_${employee.id}_q${quarter}_fed_tax`),
//     //                 stateTax: formData.get(`employee_${employee.id}_q${quarter}_state_tax`),
//     //             };
//     //         }).filter((data) => data.amount || data.fedTax || data.stateTax);
//     //     }).flat();

//     //     try {
//     //         await api.post(`/business/${businessId}/previous-payroll`, payrollData);
//     //         alert("Payroll data saved successfully!");
//     //     } catch (error) {
//     //         console.error("Error saving payroll data:", error);
//     //         alert("Failed to save payroll data.");
//     //     }
//     // };

//     return (
//         <div>
//             <h2>Add Previous Payroll</h2>
//             {employees.length === 0 ? (
//                 <p>No employees found for this business.</p>
//             ) : (
//                 <form onSubmit={handleSubmit}>
//                     {employees.map((employee) => (
//                         <div key={employee.id}>
//                             <h3>{employee.name}</h3>
//                             <table>
//                                 <thead>
//                                     <tr>
//                                         <th>Quarter</th>
//                                         <th>Amount</th>
//                                         <th>Fed Tax</th>
//                                         <th>State Tax</th>
//                                     </tr>
//                                 </thead>
//                                 <tbody>
//                                     {[...Array(quarters)].map((_, index) => {
//                                         const quarter = index + 1;
//                                         return (
//                                             <tr key={quarter}>
//                                                 <td>Q{quarter}</td>
//                                                 <td>
//                                                     <input
//                                                         type="number"
//                                                         name={`employee_${employee.id}_q${quarter}_amount`}
//                                                     />
//                                                 </td>
//                                                 <td>
//                                                     <input
//                                                         type="number"
//                                                         name={`employee_${employee.id}_q${quarter}_fed_tax`}
//                                                     />
//                                                 </td>
//                                                 <td>
//                                                     <input
//                                                         type="number"
//                                                         name={`employee_${employee.id}_q${quarter}_state_tax`}
//                                                     />
//                                                 </td>
//                                             </tr>
//                                         );
//                                     })}
//                                 </tbody>
//                             </table>
//                         </div>
//                     ))}
//                     <button type="submit">Save Payroll</button>
//                 </form>
//             )}
//         </div>
//     );
// };

// export default AddPreviousPayrollPage;





// import React, { useEffect, useState } from "react";
// import { useParams } from "react-router-dom";
// import api from "../services/api";

// const AddPreviousPayrollPage = () => {
//     const { id: businessId } = useParams(); // Extract business ID from the URL
//     const [employees, setEmployees] = useState([]);
//     const [quarters, setQuarters] = useState(0); // Number of quarters from the start of the year

//     useEffect(() => {
//         const fetchEmployees = async () => {
//             try {
//                 const { data } = await api.get(`/businesses/${businessId}/employees`);
//                 setEmployees(data);
//             } catch (error) {
//                 console.error("Error fetching employees:", error.response?.data || error.message);
//                 alert("Failed to fetch employees.");
//             }
//         };

//         const calculateQuarters = () => {
//             const currentMonth = new Date().getMonth() + 1; // JavaScript months are 0-based
//             const quarter = Math.ceil(currentMonth / 3);
//             setQuarters(quarter);
//         };

//         fetchEmployees();
//         calculateQuarters();
//     }, [businessId]);

//     const handleSubmit = (e) => {
//         e.preventDefault();
//         const formData = new FormData(e.target);

//         // Collect data for each employee
//         const payrollData = employees.map((employee) => {
//             const data = [];
//             for (let i = 1; i <= quarters; i++) {
//                 data.push({
//                     employeeId: employee.id,
//                     quarter: i,
//                     amount: formData.get(`employee_${employee.id}_q${i}_amount`),
//                     fedTax: formData.get(`employee_${employee.id}_q${i}_fed_tax`),
//                     addFed: formData.get(`employee_${employee.id}_q${i}_add_fed`),
//                     stateTax: formData.get(`employee_${employee.id}_q${i}_state_tax`),
//                     addState: formData.get(`employee_${employee.id}_q${i}_add_state`),
//                 });
//             }
//             return data;
//         });

//         console.log("Payroll Data:", payrollData);

//         // Submit payroll data to backend
//         alert("Previous payroll data saved successfully!");
//     };

//     return (
//         <div>
//             <h2>Add Previous Payroll</h2>
//             {employees.length === 0 ? (
//                 <p>No employees found for this business.</p>
//             ) : (
//                 <form onSubmit={handleSubmit}>
//                     {employees.map((employee) => (
//                         <div key={employee.id} style={{ marginBottom: "40px" }}>
//                             <h3>{employee.name}</h3>
//                             <table style={{ width: "100%", borderCollapse: "collapse" }}>
//                                 <thead>
//                                     <tr>
//                                         <th style={{ textAlign: "left", padding: "10px", borderBottom: "1px solid #ccc" }}>
//                                             Tax/Withholding
//                                         </th>
//                                         {[...Array(quarters)].map((_, index) => (
//                                             <th
//                                                 key={index}
//                                                 style={{ textAlign: "center", padding: "10px", borderBottom: "1px solid #ccc" }}
//                                             >
//                                                 Q{index + 1}
//                                             </th>
//                                         ))}
//                                     </tr>
//                                 </thead>
//                                 <tbody>
//                                     {[
//                                         { label: "Amount", key: "amount" },
//                                         { label: "Federal Income Tax", key: "fed_tax" },
//                                         { label: "Additional Federal Withholding", key: "add_fed" },
//                                         { label: "State Tax", key: "state_tax" },
//                                         { label: "Additional State Withholding", key: "add_state" },
//                                     ].map((row) => (
//                                         <tr key={row.key}>
//                                             <td style={{ padding: "10px" }}>{row.label}</td>
//                                             {[...Array(quarters)].map((_, index) => (
//                                                 <td
//                                                     key={index}
//                                                     style={{
//                                                         padding: "10px",
//                                                         textAlign: "center",
                                                        
//                                                     }}
//                                                 >
//                                                     <input
//                                                         type="number"
//                                                         placeholder={row.label}
//                                                         name={`employee_${employee.id}_q${index + 1}_${row.key}`}
//                                                         style={{ width: "100px" }}
//                                                     />
//                                                 </td>
//                                             ))}
//                                         </tr>
//                                     ))}
//                                 </tbody>
//                             </table>
//                         </div>
//                     ))}
//                     <div style={{ marginTop: "20px" }}>
//                         <button type="submit">Save Payroll</button>
//                     </div>
//                 </form>
//             )}
//         </div>
//     );
// };

// export default AddPreviousPayrollPage;

